import React, {Fragment} from 'react';

const HtmlBlock = ({key, template, className}) => {
    return (
         <div className={className} key={key} dangerouslySetInnerHTML={{__html: template}} />
    );
};

export default HtmlBlock;